import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import AppRouter from '@routes/index';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
  
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
  

ReactDOM.render(<AppRouter />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx